// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:08:51

export default {
  "id": "emoji-smasher-smiley-game",
  "slug": "emoji-smasher-smiley-game",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/949529aaea9841cf8f410b19e6d71619-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/949529aaea9841cf8f410b19e6d71619/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Emoji Smasher - Smiley Game",
      "description": "Emoji Smasher is a Hyper Casual game to make you smile while playing!\nGuess the emoticon expressions in this fast-paced challenge! Tap on emojis and win this lively, emoji-filled adventure.",
      "instructions": "Tap on the Sad and Angry Smileys and make them happy. One-tap easy-to-play with stunning visual effects and addictive game-play mechanics.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "angry",
        "cute",
        "emojis",
        "kidgames",
        "smash"
      ]
    },
    "zh-CN": {
      "title": "表情破坏者 - 笑脸游戏",
      "description": "表情粉碎器是一款让你在游戏中微笑的超休闲游戏！在这场快速挑战中猜出表情符号的表情！点击表情符号，赢得这场充满活力的表情符号冒险。",
      "instructions": "点击悲伤和生气的笑脸，让它们变得开心。一触即玩，拥有惊人的视觉效果和上瘾的游戏玩法机制。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "愤怒",
        "可爱",
        "表情符号",
        "儿童游戏",
        "打碎"
      ]
    },
    "zh-TW": {
      "title": "表情符粉碎者 - 笑臉遊戲",
      "description": "Emoji Smasher 是一款讓你在遊戲中笑出來的極簡遊戲！猜猜這個快速挑戰中的表情圖示！點擊表情圖示，贏得這場充滿生氣、充滿表情圖示的冒險。",
      "instructions": "點擊哀傷和生氣的臉書表情，讓他們開心起來。一點即可玩，簡單易上手的遊戲方式，搭配驚艷的視覺效果和上癮的遊戲機制。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "生氣的",
        "可愛的",
        "表情圖標",
        "兒童遊戲",
        "擊毀"
      ]
    },
    "zh-HK": {
      "title": "表情消消樂 - 笑臉遊戲",
      "description": "表情擊碎是一個超級休闲遊戲，讓你在遊戲中展露笑顏！在這個快速挑戰中猜測表情圖標表情！輕觸表情圖標，贏得這個生動、充滿表情圖標的冒險之旅。",
      "instructions": "按壓悲傷和生氣的表情圖，讓他們變得快樂。一觸即發，簡單易玩，並帶有驚艷的視覺效果和上癮的遊戲機制。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "怒",
        "可愛",
        "表情圖",
        "兒童遊戲",
        "擊毀"
      ]
    },
    "ja": {
      "title": "絵文字クラッシュ - 顔文字ゲーム",
      "description": "Emoji Smasherは、遊びながら笑顔にしてくれるハイパーカジュアルゲームです！\n速いペースで楽しむことで、アイコン表情を当てて勝利しよう！アイコンをタップして、生き生きとしたアイコンに満ちた冒険に勝利しよう！",
      "instructions": "悲しそうで怒っているアイコンをタップして幸せにしてください。ワンタップで簡単に遊べ、目を見張るような視覚効果と魅力的なゲームプレイメカニクスが特徴です。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "怒った",
        "可愛い",
        "絵文字",
        "子供のゲーム",
        "バトル"
      ]
    },
    "ko": {
      "title": "에모지 스마셔 - 스미iley 게임",
      "description": "Emoji Smasher는Playing을 통해 웃음을 주는 하이퍼 캐주얼 게임입니다!\n이 빠른 템포의 도전에서 이모티콘 표정을 추측해 보세요! 이모티콘을 탭하고 이 활기차고 이모티콘 채우는 모험을 승리하세요.",
      "instructions": "슬퍼하고 화난 미니언스를 탭하여 기쁨을 주세요. 한 번 탭만으로 쉽게 플레이하고, 반짝이는 시각적 효과와 약간의 게임 플레이 메커니즘을 즐기세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "怒한",
        "귀여운",
        "이모지",
        "어린이게임",
        "쳐부수기"
      ]
    },
    "fr": {
      "title": "Emoji Smasher - Jeu Smiley",
      "description": "Emoji Smasher est un jeu Hyper Casual pour vous faire sourire en jouant !\nDevinez les expressions d'émoticônes dans ce défi rapide ! Tapez sur les émoticônes et gagnez cette aventure animée pleine d'émoticônes.",
      "instructions": "Tapez sur les smileys tristes et en colère pour les rendre heureux. Jeu facile à jouer en un seul tap, avec des effets visuels éblouissants et des mécanismes de jeu accrocheurs.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "enragé",
        "mignon",
        "emojis",
        "jeux pour enfants",
        "écraser"
      ]
    }
  }
};
